module.exports = __webpack_public_path__ + "img/Graphics.4ed47348.png";